import { filterStyles as styles } from "@iewccouk/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

styles.shipToGridItem = {
    ...styles.shipToGridItem,
    width: [12, 12, 6, 6, 3],
};

styles.invoiceNumberGridItem = {
    ...styles.invoiceNumberGridItem,
    width: [12, 12, 3, 3, 3],
};

styles.orderNumberGridItem = {
    ...styles.orderNumberGridItem,
    width: [12, 12, 3, 3, 3],
};

styles.poNumberGridItem = {
    ...styles.poNumberGridItem,
    width: [12, 12, 3, 3, 3],
};

styles.clearFiltersButton = {
    ...styles.clearFiltersButton,
    css: css`
        ${styles.clearFiltersButton?.css}
        margin-right: 0;
    `,
};

/* Verndale Custom Feature - New styles */
styles.invoiceTypeGridItem = {
    width: [12, 12, 3, 3, 3],
};

styles.invoiceStatusGridItem = {
    width: [12, 12, 3, 3, 3],
};
